import { apiGet, apiPatch } from './client';
import type {
  DisclosureLevel4,
  DisclosureLevel4BatchRequest,
} from '../types/DisclosureLevel4';

export function getDisclosureLevel4(): Promise<DisclosureLevel4[]> {
  return apiGet<DisclosureLevel4[]>('/api/disclosure-level-4');
}

export function saveBatchDisclosureLevel4(
  added: DisclosureLevel4[],
  modified: DisclosureLevel4[],
  deletedIds: string[],
): Promise<DisclosureLevel4[]> {
  return apiPatch<DisclosureLevel4BatchRequest, DisclosureLevel4[]>(
    '/api/disclosure-level-4/batch',
    { added, modified, deleted: deletedIds },
  );
}
